"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = poll;
function poll(pollee) {
    let timeoutId;
    let isActive = true;
    function stop() {
        isActive = false;
        clearTimeout(timeoutId);
    }
    async function nextPoll() {
        try {
            const delay = await pollee(stop);
            if (!isActive || typeof delay !== 'number') {
                return;
            }
            timeoutId = setTimeout(nextPoll, delay);
        }
        catch (e) {
        }
    }
    nextPoll();
    return stop;
}
